import React, { useState } from 'react';
import {
  Box,
  Grid,
  Card,
  Stack,
  Chip,
  Tabs,
  Tab,
  Button,
  Typography,
  IconButton,
} from '@mui/material';

import { LuPencil, LuTag, LuUsersRound } from 'react-icons/lu';
import { BiDollarCircle } from "react-icons/bi";
import { MdMoreVert } from 'react-icons/md';
import { IoSettingsOutline, IoWalletOutline } from 'react-icons/io5';
import { TbCancel} from "react-icons/tb";
import { CiPause1 } from 'react-icons/ci';
import RulesEligibilityTab from './RulesEligibilityTab';
import RedemptionsCashbackTab from './RedemptionsCashbackTab';
import ActivityLogCashbackTab from './ActivityLogCashbackTab';
import OverviewCashBackTab from './OverviewCashBackTab';
import BudgetUsageCashBackTab from './BudgetUsageCashBackTab';
import { GrPieChart } from 'react-icons/gr';


const mockCashback = {
  code: '10K Cashback on Maintenance',
  id: 'CB-00012',
  status: 'Active',
  stats: {
    totalCashbackAwarded: 245000,
    totalOrdersVolume: 1850000,
    remainingBudget: 313500,
    walletConversionRate: 68.5,
    cashbackRecipients: 1850,
  },
  basicInfo: {
    triggerType: 'Purchased via App',
    cashbackValue: 10,
    maxCapPerOrder: 150,
    minOrderSpend: 500,
    validityPeriod: 180,
    maxUsesPerUser: '1 per customer',
    totalClaimsLimit: 1000,
    remainingClaims: 650,
    remainingClaimsPercent: 65.0,
    status: 'Active',
  },
  validity: {
    startDate: 'May 15, 2026 12:00 am',
    endDate: 'May 31, 2026 11:59 am',
    days: 16,
    timeRestriction: 'No',
  },
  fundingLiability: {
    fundingSource: 'ESTBN',
    estbnShare: 100,
    providerShare: 0,
    totalCommittedBudget: 500000,
    totalRedeemedCost: 186500,
    remainingBudget: 313500,
    remainingBudgetPercent: 62.4,
  },
  eligibilityRulesOverview: {
    eligibleCustomers: 'All Customers',
    customerTiers: 'All Tiers',
    eligibleServices: 'Package Services',
    excludedItems: 'Parts Only Orders',
    stacking: 'Non-stackable',
    walletValidity: 30,
    eligiblePaymentMethods: 'Credit Card / Online',
  },
  quickInsights: [
    { type: 'budget', text: '62.4% of total cashback budget consumed' },
    { type: 'users', text: '1,850 unique customers received cashback' },
    { type: 'discount', text: 'Average cashback per order: 125 EGP' },
  ],
  cashbackIssuanceTrend: [
    { date: 'Apr 22', redemptions: 180 },
    { date: 'Apr 25', redemptions: 340 },
    { date: 'Apr 29', redemptions: 560 },
    { date: 'May 02', redemptions: 400 },
    { date: 'May 06', redemptions: 230 },
    { date: 'May 09', redemptions: 260 },
    { date: 'May 13', redemptions: 300 },
    { date: 'May 16', redemptions: 210 },
    { date: 'May 20', redemptions: 150 },
  ],
  eligibilitySummary: {
    subtitle: 'This cashback campaign is available to users who meet all the eligibility conditions below',
    eligibleUsers: 3200,
    excludedUsers: 420,
    pendingCheck: 85,
    totalEvaluated: 3705,
    status: 'Active',
  },
  includeUsersRules: [
    { id: 1, rule: 'Payment Method', condition: 'is', value: 'Credit Card / Online', match: 'AND', status: 'Active' },
    { id: 2, rule: 'Min Order Value', condition: 'greater than or equal', value: '500 EGP', match: 'AND', status: 'Active' },
    { id: 3, rule: 'Customer Segment', condition: 'is', value: 'VIP Customers', match: 'AND', status: 'Active' },
    { id: 4, rule: 'Eligible Services', condition: 'is one of', value: 'Maintenance Checkup', match: 'AND', status: 'Active' },
  ],
  excludeUsersRules: [
    { id: 1, rule: 'Payment Method', condition: 'is', value: 'Cash on Delivery', match: 'OR', status: 'Active' },
    { id: 2, rule: 'Account Status', condition: 'is', value: 'Suspended', match: 'OR', status: 'Active' },
    { id: 3, rule: 'Employee Accounts', condition: 'is', value: 'Internal Employee', match: 'OR', status: 'Active' },
    { id: 4, rule: 'Excluded Services', condition: 'is one of', value: 'Spare Parts Only Orders', match: 'OR', status: 'Active' },
  ],
  ruleHealth: {
    status: 'Healthy',
    message: 'All rules are valid',
    subMessage: 'No conflicts detected',
  },
  cashbackRules: [
    { label: 'Cashback Type', value: 'Percentage' },
    { label: 'Cashback Value', value: '10%' },
    { label: 'Minimum Order Value', value: '0 EGP' },
    { label: 'Max Cashback Cap', value: '150 EGP' },
    { label: 'Wallet Expiry Period', value: '30 Days' },
    { label: 'Cashback Payout Event', value: 'After Order Completion' },
    { label: 'Usage Limit', value: '1 time per customer' },
    { label: 'Stackable', value: 'No' },
    { label: 'Applicable Categories', value: 'All Categories' },
    { label: 'Payment Method', value: 'Online / Credit Card' },
    { label: 'Validity', value: 'Mar 10 - May 31, 2026' },
  ],
  validationChecklist: [
    'Cashback is active',
    'Cashback cap is defined',
    'Rules configured correctly',
    'Usage limit is valid',
    'Target audience size is valid',
  ],
  redemptionSummary: {
    totalCashbackIssued: 1284,
    uniqueUsers: 982,
    avgCashbackPerOrder: 80,
    totalAwardedAmount: 102720,
    totalSalesGenerated: 120000,
  },
  redemptionOverTime: {
    granularity: 'Daily',
    dateRangeLabel: 'Mar 10, 2025 - May 31, 2025',
    data: [
      { date: 'Mar 10', redemptions: 20 },
      { date: 'Mar 17', redemptions: 65 },
      { date: 'Mar 24', redemptions: 110 },
      { date: 'Mar 31', redemptions: 130 },
      { date: 'Apr 07', redemptions: 165 },
      { date: 'Apr 21', redemptions: 165 },
      { date: 'Apr 28', redemptions: 115 },
      { date: 'May 05', redemptions: 105 },
      { date: 'May 12', redemptions: 145 },
      { date: 'May 19', redemptions: 190 },
      { date: 'May 26', redemptions: 175 },
      { date: 'May 31', redemptions: 205 },
    ],
  },
  recentRedemptions: [
    { id: 'RED-1248', user: 'Mona Salah', dateTime: 'May 18, 2025 - 02:15 pm', orderId: 'ORD-3549', orderValue: 420, cashbackEarned: 80, status: 'Completed', walletStatus: 'Credited' },
    { id: 'RED-1247', user: 'Mona Salah', dateTime: 'May 18, 2025 - 02:15 pm', orderId: 'ORD-3549', orderValue: 420, cashbackEarned: 80, status: 'Completed', walletStatus: 'Credited' },
    { id: 'RED-1246', user: 'Mona Salah', dateTime: 'May 18, 2025 - 02:15 pm', orderId: 'ORD-3549', orderValue: 420, cashbackEarned: 80, status: 'Completed', walletStatus: 'Spent' },
    { id: 'RED-1245', user: 'Mona Salah', dateTime: 'May 18, 2025 - 02:15 pm', orderId: 'ORD-3549', orderValue: 420, cashbackEarned: 80, status: 'Completed', walletStatus: 'Credited' },
    { id: 'RED-1244', user: 'Mona Salah', dateTime: 'May 18, 2025 - 02:15 pm', orderId: 'ORD-3549', orderValue: 420, cashbackEarned: 80, status: 'Completed', walletStatus: 'Expired' },
    { id: 'RED-1243', user: 'Mona Salah', dateTime: 'May 18, 2025 - 02:15 pm', orderId: 'ORD-3549', orderValue: 420, cashbackEarned: 80, status: 'Completed', walletStatus: 'Credited' },
    { id: 'RED-1242', user: 'Mona Salah', dateTime: 'May 18, 2025 - 02:15 pm', orderId: 'ORD-3549', orderValue: 420, cashbackEarned: 80, status: 'Completed', walletStatus: 'Spent' },
  ],
  redemptionByStatus: {
    total: 256,
    segments: [
      { label: 'Completed', value: 1152, percent: 89.6, color: '#3FBEAC' },
      { label: 'Pending', value: 100, percent: 10.0, color: '#FEB91E' },
      { label: 'Cancelled', value: 20, percent: 1.6, color: '#A80101' },
    ],
  },
  redemptionByChannel: [
    { label: 'Mobile App', value: 912, percent: 71.0 },
    { label: 'Website', value: 232, percent: 18.1 },
    { label: 'Call Center', value: 96, percent: 7.5 },
    { label: 'POS', value: 44, percent: 3.4 },
  ],
  topRedeemingUsers: [
    { name: 'Osama Ali', activities: 24, },
    { name: 'Ahmed Hassan', activities: 18, },
    { name: 'Amr Hassan', activities: 17, },
    { name: 'Mona Salah', activities: 15,},
  ],
  redemptionInsights: [
    'Redemption rate is 12% higher than average for similar cashback campaigns.',
    'Mobile App is the top channel with 71% of total redemptions.',
    'Most redemptions occur on weekends.',
  ],
  budgetReview: {
    totalBudget: 100000,
    consumedBudget: 35000,
    remainingBudget: 65000,
    utilization: 35,
  },
  budgetConsumption: {
    used: 35000,
    total: 100000,
  },
  fundingAllocation: {
    total: 100000,
    platform: 70000,
    provider: 30000,
  },
  budgetRedemptionSummary: {
    totalClaims: 230,
    totalCashbackAwarded: 35000,
    avgCashbackPerOrder: 152,
    remainingClaims: 770,
  },
  budgetHistory: [
    { date: 'Apr 21', amount: 2000 },
    { date: 'Apr 23', amount: 6000 },
    { date: 'Apr 25', amount: 10000 },
    { date: 'Apr 27', amount: 14000 },
    { date: 'Apr 29', amount: 17000 },
    { date: 'May 01', amount: 20000 },
    { date: 'May 03', amount: 22000 },
    { date: 'May 05', amount: 24000 },
    { date: 'May 07', amount: 24500 },
    { date: 'May 09', amount: 27000 },
    { date: 'May 11', amount: 29000 },
    { date: 'May 13', amount: 33000 },
    { date: 'May 15', amount: 37000 },
    { date: 'May 17', amount: 39000 },
    { date: 'May 19', amount: 45000 },
  ],
  budgetHealth: {
    status: 'Healthy',
    message: 'Your budget is on track',
  },
  fundingSplit: {
    platform: 70000,
    platformPercent: 70,
    provider: 30000,
    providerPercent: 30,
    total: 100000,
  },
  budgetRules: [
    { label: 'Budget Type', value: 'Fixed Budget' },
    { label: 'Budget Limit', value: '100,000 EGP' },
    { label: 'Auto Pause', value: 'Enabled', isChip: true },
    { label: 'Pause Threshold', value: '95%' },
    { label: 'Allow Over Budget', value: 'No' },
    { label: 'Max Claims Cap', value: '1,000 Claims' },
  ],
  budgetAlerts: {
    hasActiveAlerts: false,
    notifications: ['You will be notified when budget utilization reaches 85%'],
  },
  activityLog: {
    dateRangeLabel: 'Mar 10, 2025 - May 31, 2025',
    pagination: {
      shown: 1,
      pages: 8,
      total: 48,
      current: 1,
      pageButtons: [1, 2, 3, '…', 10],
    },
    entries: [
      {
        id: 'ACT-1',
        date: 'May 31, 2025',
        time: '10:45 am',
        user: 'Sarah Ahmed',
        role: 'Admin',
        action: 'Created Cashback Campaign',
        category: 'Cashback Creation',
        detailLabel: 'Initial Cap:',
        detailValue: '10% (Max 150 EGP)',
        ipAddress: '197.168.1.12',
      },
      {
        id: 'ACT-2',
        date: 'May 31, 2025',
        time: '09:30 am',
        user: 'Sarah Ahmed',
        role: 'Admin',
        action: 'Resumed Campaign',
        category: 'Status Change',
        detailLabel: 'Campaign resumed',
        detailValue: 'manually',
        ipAddress: '197.168.1.12',
      },
      {
        id: 'ACT-3',
        date: 'May 30, 2025',
        time: '04:15 pm',
        user: 'Omar Hassan',
        role: 'Manager',
        action: 'Updated Budget Limit',
        category: 'Budget Update',
        detailLabel: 'Changed from:',
        detailValue: '300,000 EGP to 500,000 EGP',
        ipAddress: '197.168.1.15',
      },
      {
        id: 'ACT-4',
        date: 'May 29, 2025',
        time: '02:20 pm',
        user: 'Ahmed Ali',
        role: 'Supervisor',
        action: 'Cashback Awarded',
        category: 'Cashback Issue',
        detailLabel: 'Claim ID: CB-9821',
        detailValue: 'Amount: 80 EGP Credited',
        ipAddress: '197.168.1.21',
      },
      {
        id: 'ACT-5',
        date: 'May 27, 2025',
        time: '11:05 am',
        user: 'Sarah Ahmed',
        role: 'Admin',
        action: 'Resumed Budget',
        category: 'Budget Update',
        detailLabel: 'Changed from:',
        detailValue: '300,000 EGP to 500,000 EGP',
        ipAddress: '197.168.1.12',
      },
      {
        id: 'ACT-6',
        date: 'May 26, 2025',
        time: '06:40 pm',
        user: 'System',
        role: 'System',
        action: 'Cashback Awarded',
        category: 'Cashback Issue',
        detailLabel: 'Claim ID: CB-9821',
        detailValue: 'Amount: 150 EGP Credited',
        ipAddress: '10.0.0.5',
      },
    ],
  },
  activitySummary: {
    dateRangeLabel: 'May 20 - May 31, 2025',
    totalActivities: 48,
    budgetChanges: 12,
    ruleUpdates: 9,
    cashbackClaims: 27,
  },
  topUsers: [
    { name: 'Sarah Ahmed', role: 'Admin', activities: 18, initials: 'SA', avatarBg: '#F6E9FC', color: "#7E1BAD" },
    { name: 'Omar Hassan', role: 'Manager', activities: 12, initials: 'OH', avatarBg: '#F4F8F0', color: "#8CB369" },
    { name: 'Ahmed Ali', role: 'Supervisor', activities: 8, initials: 'AA', avatarBg: '#F0F8FF', color: "#3E9FF6" },
    { name: 'System', role: 'System', activities: 10, initials: '', avatarBg: '#F8F8F8', icon: <IoSettingsOutline size={16} color="#696969" /> },
    
  ],
};

const ACCENT = '#3FBEAC';
const BORDER = '#E8E8E8';

const currencyEGP = (n) => `${Number(n).toLocaleString()} EGP`;

const StatCard = ({ icon, iconColor, iconBg, label, value }) => (
  <Card variant="outlined" sx={{ borderRadius: 3, p: 2, borderColor: BORDER, height: '100%' }}>
    <Stack direction="row" spacing={1.5} alignItems="center">
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: '50%',
          bgcolor: iconBg,
          color: iconColor,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        {icon}
      </Box>
      <Typography variant="body2" color="#535353">
        {label}
      </Typography>
    </Stack>
    <Typography variant="h6" fontWeight={700} sx={{ mt: 1.5 }}>
      {value}
    </Typography>
  </Card>
);

const TABS = ['Overview', 'Rules & Eligibility', 'Redemptions', 'Budget & Usage', 'Activity Log'];

const CashbackDetails = ({ data = mockCashback }) => {
  const [tab, setTab] = useState(0);

  return (
    <Box sx={{ m: { xs: 2, md: 4 } }}>

      {/* Header */}
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        justifyContent="space-between"
        alignItems={{ xs: 'flex-start', sm: 'flex-start' }}
        spacing={2}
        sx={{ mb: 3, flexWrap: 'wrap' }}
      >
        <Box>
          <Stack direction="row" spacing={1.5} alignItems="center" flexWrap="wrap">
            <Typography variant="h5" fontWeight={700}>
              {data.code}
            </Typography>
            <Chip
              size="small"
              label={data.status}
              sx={{ bgcolor: '#ECF9F7', fontWeight: 600, px: 1 }}
            />
          </Stack>
          <Typography variant="body2" color="#535353" sx={{ mt: 0.5 }}>
            {data.id}
          </Typography>
        </Box>

        <Stack direction="row" spacing={2} sx={{ flexWrap: 'wrap', gap: 1.5, rowGap: 1.5 }}>
          <Button
            variant="outlined"
            startIcon={<LuPencil size={18} />}
            sx={{ textTransform: 'none', color: '#000000', gap: .4, borderColor: "#E8E8E8" }}
          >
            Edit
          </Button>
          <Button
            variant="outlined"
            startIcon={<CiPause1 size={18} />}
            sx={{ textTransform: 'none', color: '#000000', gap: .4, borderColor: "#E8E8E8" }}
          >
            Pause
          </Button>
          <Button
            variant="outlined"
            startIcon={<TbCancel size={18} />}
            sx={{ textTransform: 'none', color: '#A80101', gap: .4, borderColor: "#E8E8E8" }}
          >
            Disable
          </Button>
          <IconButton sx={{ border: '1px solid #E0E3E8', borderRadius: 1.5 }}>
            <MdMoreVert size={18} />
          </IconButton>
        </Stack>
      </Stack>

      {/* Stat cards */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={2.4}>
          <StatCard
            icon={<BiDollarCircle size={25} />}
            iconColor="#FFFFFF"
            iconBg="#696969"
            label="Total Cashback Awarded"
            value={currencyEGP(data.stats.totalCashbackAwarded)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2.4}>
          <StatCard
            icon={<LuTag size={25} />}
            iconColor="#FFFFFF"
            iconBg="#7E1BAD"
            label="Total Orders Volume"
            value={currencyEGP(data.stats.totalOrdersVolume)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2.4}>
          <StatCard
            icon={<IoWalletOutline size={25} />}
            iconColor="#FFFFFF"
            iconBg="#000000"
            label="Remaining Budget"
            value={currencyEGP(data.stats.remainingBudget)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2.4}>
          <StatCard
            icon={<GrPieChart size={25} />}
            iconColor="#FFFFFF"
            iconBg="#3E9FF6"
            label="Wallet Conversion Rate"
            value={`${data.stats.walletConversionRate}%`}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2.4}>
          <StatCard
            icon={<LuUsersRound size={25} />}
            iconColor="#FFFFFF"
            iconBg="#FEB91E"
            label="Cashback Recipients"
            value={data.stats.cashbackRecipients.toLocaleString()}
          />
        </Grid>
      </Grid>

      {/* Tabs */}
      <Box className="custom-tab-style">
        <Tabs
          value={tab}
          onChange={(e, v) => setTab(v)}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            mb: 3,
            minHeight: 40,
            borderBottom: `1px solid ${BORDER}`,
            '& .MuiTabs-indicator': { backgroundColor: ACCENT, height: 2.5 },
          }}
        >
          {TABS.map((t) => (
            <Tab
              key={t}
              label={t}
              sx={{
                textTransform: 'none',
                minHeight: 40,
                color: '#535353',
                '&.Mui-selected': { color: "#000000" },
              }}
            />
          ))}
        </Tabs>
      </Box>

      {/* Tab content */}
      {tab === 0 && <OverviewCashBackTab data={data} />}
      {tab === 1 && <RulesEligibilityTab data={data} />}
      {tab === 2 && <RedemptionsCashbackTab data={data} />}
      {tab === 3 && <BudgetUsageCashBackTab data={data} />}
      {tab === 4 && <ActivityLogCashbackTab data={data} />}
    </Box>
  );
};

export default CashbackDetails;